import { MAX_FILE_SIZE_BYTES } from "src/utils/files";
import { pluralize } from "src/utils/stringUtils";

const MAX_FILE_SIZE_MB = MAX_FILE_SIZE_BYTES / 1024 ** 2;

export const SIZE_FORMAT_HINT = `Check that each file is under ${MAX_FILE_SIZE_MB} MB and in a supported format.`;

const SIZE_FORMAT_BLOCK = `Too large or unsupported format. Each file must be under ${MAX_FILE_SIZE_MB} MB:`;

const UPLOAD_BLOCK = "Upload did not complete. Add these files again:";

const UPLOAD_HINT = "Add them again.";

const FileNameList: React.FC<{ files: File[] }> = ({ files }) => (
  <ul className="list-disc pl-4">
    {files.map((file, index) => (
      // Two picked files can share a name, and the list never reorders.
      <li key={index}>{file.name}</li>
    ))}
  </ul>
);

/** The count says "failed to upload", so each block below only names its cause. */
export const FailureDescriptionRow: React.FC<{
  refusedFiles: File[];
  failedFiles: File[];
}> = ({ refusedFiles, failedFiles }) => {
  const count = pluralize(refusedFiles.length + failedFiles.length, "file");

  if (refusedFiles.length > 0 && failedFiles.length > 0) {
    return (
      <div>
        {`${count} failed to upload.`}
        <div>{SIZE_FORMAT_BLOCK}</div>
        <FileNameList files={refusedFiles} />
        <div>{UPLOAD_BLOCK}</div>
        <FileNameList files={failedFiles} />
      </div>
    );
  }

  const onlyRefused = refusedFiles.length > 0;

  return (
    <div>
      {`${count} failed to upload. ${onlyRefused ? SIZE_FORMAT_HINT : UPLOAD_HINT}`}
      <FileNameList files={onlyRefused ? refusedFiles : failedFiles} />
    </div>
  );
};
